import React from 'react'

const ModernBankingHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
            <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                    <div className='min-w-0 max-w-full'>
                        <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                            Modernizing Banking Infrastructure
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Microservices
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Kubernetes
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                              We partnered with a leading APAC fintech company that has transformed 150+ banks worldwide to architect
                              their next-generation cloud-native banking platform. Our microservices-based solution successfully handles
                              2 million users on peak days and 500,000+ daily active users with API response times under 3 seconds,
                              deployed on AWS using Docker and Kubernetes with Horizontal Pod Autoscaling. The platform revolutionized
                              customer banking experiences through personalized services, seamless third-party integrations, and
                              OAuth 2.0 security, establishing new standards for modern digital banking infrastructure.
                            </p>

                    </div>
                    <div className='min-w-0 max-w-full'>
                      <img src='/case_studies/title-banner/banking-app-title-banner.png' alt='Modern Banking Infrastructure' className='w-full h-auto max-w-full'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ModernBankingHero
